import { Plug } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import BillingConnectionCard from "./BillingConnectionCard";
import TriageConnectionCard from "./TriageConnectionCard";
import PlannerConnectorCard from "./PlannerConnectorCard";
import MicrosoftMailCard from "./MicrosoftMailCard";
import GithubConnectionCard from "./GithubConnectionCard";
import CallImportCard from "./CallImportCard";

const PANELS = [
  ["microsoft", "Microsoft 365", MicrosoftMailCard],
  ["billing", "Billing", BillingConnectionCard],
  ["triage", "Atlassian", TriageConnectionCard],
  ["github", "GitHub", GithubConnectionCard],
  ["recordings", "Call recordings", CallImportCard],
  ["planner", "Claude Connector", PlannerConnectorCard],
];

/* Every third-party connection in one place, one per tab. Keys themselves live
   in the server environment (never the database, because preview and production
   share one database and a stored key would put both on the same account) — so
   this page reports state and never accepts a secret. */
export default function AdminIntegrations() {
  return (
    <div className="space-y-6" data-testid="admin-integrations">
      <Card className="bg-white border-[#DAD5CA]">
        <CardContent className="p-5">
          <div className="flex items-center gap-2">
            <Plug className="w-4 h-4 text-[#59554D]" />
            <div>
              <h3 className="text-[15px] font-bold text-[#1A1A1A]">Integrations &amp; Keys</h3>
              <p className="text-[12.5px] text-[#59554D]">
                Whether each connected service is reachable, which account it is pointed at, and what to
                fix when it is not. Third-party credentials are set as deployment secrets, so no secret
                here is ever displayed. The one exception is the planner connector key, which this app
                issues itself — shown once, then only ever by its last four.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Tabs defaultValue="microsoft">
        <TabsList className="flex w-full max-w-full justify-start overflow-x-auto bg-[#F4F2ED] border border-[#DAD5CA]" data-testid="integrations-tabs">
          {PANELS.map(([id, label]) => (
            <TabsTrigger key={id} value={id} data-testid={`integrations-tab-${id}`}
              className="shrink-0 text-[12.5px] data-[state=active]:bg-white data-[state=active]:text-[#1A1A1A]">
              {label}
            </TabsTrigger>
          ))}
        </TabsList>
        {PANELS.map(([id, , Panel]) => (
          <TabsContent key={id} value={id} className="mt-4" data-testid={`integrations-panel-${id}`}>
            <Panel />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
